import { StringUtil } from '.';

export class SearchBoxUtil {
  /**
   * Will return data from clipboard
   *
   * @param {any} event
   * @returns string
   */
  public static getClipboardValue(event: any): string {
    return event.clipboardData.getData('Text');
  }

  /**
   * Will return button enable and disable base on input paste
   *
   * @param {any} event
   * @returns boolean
   */
  public static havePastedValue(event: any): boolean {
    const textOnPaste = StringUtil.removeWhiteSpaces(this.getClipboardValue(event));
    return !textOnPaste.length;
  }
}
